import { apiClient } from '../api.client';
import type { User } from '../../types/auth';
import type {
  AdminStats,
  AdminOrder,
  AdminCommunicationPayload,
  AdminCourse,
  AdminCoursePayload,
} from '../../types/admin';

export const adminReal = {
  getStats: () => apiClient.get<AdminStats>('/admin/stats'),

  getUsers: () => apiClient.get<User[]>('/admin/users'),

  getUser: (userId: string) => apiClient.get<User>(`/admin/users/${userId}`),

  blockUser: (userId: string, blocked: boolean) =>
    apiClient.patch<void>(`/admin/users/${userId}/block`, { blocked }),

  deleteUser: (userId: string) =>
    apiClient.delete<void>(`/admin/users/${userId}`),

  resetUserPassword: (userId: string) =>
    apiClient.post<void>(`/admin/users/${userId}/reset-password`, {}),

  getOrders: () => apiClient.get<AdminOrder[]>('/admin/orders'),

  sendCommunication: (payload: AdminCommunicationPayload) =>
    apiClient.post<void>('/admin/communications', payload),

  getCourses: () => apiClient.get<AdminCourse[]>('/admin/courses'),

  createCourse: (payload: AdminCoursePayload) =>
    apiClient.post<AdminCourse>('/admin/courses', payload),

  updateCourse: (id: string, payload: Partial<AdminCoursePayload>) =>
    apiClient.patch<AdminCourse>(`/admin/courses/${id}`, payload),
};
